import * as React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableShiftsCrews } from "./components/TableShifts";

export const ShiftsCrews = () => {
	return (
		<>
			<HelmetDexteel title="Shifts and Crews" />
			<TableShiftsCrews />
		</>
	);
};
